import menu from './menu';
import panel from './panel';
import base from '@/i18n/cn';
import {merge} from 'lodash-es';
import dashboard from './dashboard';

export default merge(base, { menu, panel, dashboard });
